import { ParameterType } from '@/study-search/enums';
import { TitleBase } from './TitleBase';

export default class TitleTuitionFeeContinent extends TitleBase {
	private continentValue: string;

	protected canHandle(): boolean {
		this.continentValue = this.getFilterValue(ParameterType.CONTINENT);

		return (
			this.indexableFilters.length === 2 &&
			this.indexableFilters.some((_) => _.type === ParameterType.TUITION_FEE) &&
			this.indexableFilters.some((_) => _.type === ParameterType.CONTINENT)
		);
	}

	protected getPageTitle(): string {
		return `Affordable ${this.titlePortalType} in ${this.continentValue}`;
	}

	protected getMetaTitle(): string {
		return `${this.totalSearchResults} affordable ${this.titlePortalType} in ${this.continentValue} | ${this.portalName}`;
	}

	protected getMetaDescription(): string {
		return this.buildMetaDescription(`and most affordable ${this.titlePortalType} in ${this.continentValue}`);
	}
}
